import { render } from "./TopNavEditor.vue?vue&type=template&id=d5b4c9c6"
import script from "./TopNavEditor.vue?vue&type=script&lang=js"
export * from "./TopNavEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__